import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-accent-800">
            <i className="ri-bookmark-3-line" aria-hidden="true"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{description}</p>}
      </div>
      {action}
    </div>
  );
}